import { Injectable } from '@angular/core';
import { HttpProvider } from '../http/http';

/*
  Generated class for the AutoProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class AutoProvider {
  constructor(public http: HttpProvider) {
    console.log('Hello AutoProvider Provider');
  }

  createAutoReply(chatroom_list, message_list, keyword_list, keywords_id, at_switch) {
    let params = {
      chatroom_list: chatroom_list,
      message_list: message_list,
      keyword_list: keyword_list,
      keywords_id: keywords_id,
      at_switch: at_switch
    };
    return this.http.hPost('/reply/create_a_auto_reply_setting', params);
  }

  // switchAutoReply(){
  //   return this.http.hPost('/switch_func_auto_reply','')
  // }

  deleteAutoReply(keywords_id,page,pagesize) {
    return this.http.hPost('/reply/delete_a_auto_reply_setting', {
      keywords_id: keywords_id,
      page:page,
      pagesize:pagesize
    });
  }

  getAutoReplyList(page,pagesize) {
    return this.http.hPost('/reply/get_auto_reply_setting',{page:page,pagesize:pagesize});
  }
  getAutoSetting(){
    return this.http.hPost('/reply/get_switch');
  }

  switchFuncAutoReply(is_switch: boolean) {
    return this.http.hPost('/reply/switch_func_auto_reply', { switch: is_switch });
  }
}



// WEBPACK FOOTER //
// ./src/providers/auto/auto.ts